var d = /* @__PURE__ */ ((e) => (e.FreeSelection = "freeSelection", e.Limitless = "limitless", e.SelectOne = "selectOne", e.AtLeastAddons = "atLeastAddons", e.MaxAddons = "maxAddons", e.SelectInBetween = "selectInBetween", e))(d || {});
function a(e) {
  const { allowMultiple: o, freeAmount: n, maximumAmount: t, minimumAmount: s } = e, m = s !== null && s !== 0, u = t !== null && t !== 0, i = m && u && s === t, r = n && n > 0, l = !t && o, c = !o && t && t < 2 && s && s < 2;
  return r ? ["freeSelection", { numberOfFree: n }] : l ? [
    "limitless"
    /* Limitless */
  ] : c ? [
    "selectOne"
    /* SelectOne */
  ] : m && !u ? ["atLeastAddons", { minimum: s }] : u && !m || i ? ["maxAddons", { maximum: t }] : u && m ? [
    "selectInBetween",
    { minimumAmount: s, maximumAmount: t }
  ] : [void 0, void 0];
}
function f(e, o) {
  const [n, t] = a(e);
  return { translation: n ? o[n]({ key: n, meta: t }) : void 0, key: n };
}
export {
  d as SettingTranslationKey,
  f as default
};
